module.exports = __webpack_public_path__ + "img/13.ae7f8abf.png";